import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type Auction = {
  __typename?: 'Auction';
  active: Scalars['Boolean'];
  buyersPremiumPercentage: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  endsAt: Scalars['DateTime'];
  faqLink: Scalars['String'];
  heroImage: Scalars['String'];
  heroImageMobile: Scalars['String'];
  heroImageMobile2x: Scalars['String'];
  id: Scalars['ID'];
  lots: Array<Lot>;
  maxFairMarketValue: Scalars['Float'];
  overheadPremiumPercentage: Scalars['Float'];
  startsAt: Scalars['DateTime'];
  title: Scalars['String'];
  varieties: Array<Scalars['String']>;
  youtubeId: Scalars['String'];
};


export type AuctionVarietiesArgs = {
  year?: InputMaybe<Scalars['Float']>;
};

export type AuctionConnection = {
  __typename?: 'AuctionConnection';
  edges: Array<AuctionEdge>;
  pageInfo: PageInfo;
};

export type AuctionEdge = {
  __typename?: 'AuctionEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: Auction;
};

export type AuctionStats = {
  __typename?: 'AuctionStats';
  bidsCount: Scalars['Int'];
  lotsCount: Scalars['Int'];
  lotsEndedCount: Scalars['Int'];
  paddleCount: Scalars['Int'];
};

export type Bid = {
  __typename?: 'Bid';
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lot: Lot;
  paddle: Paddle;
  paddleId: Scalars['String'];
};

export type LeaderboardRank = {
  __typename?: 'LeaderboardRank';
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  paddleId: Scalars['String'];
  paddleNumber: Scalars['Float'];
  rank: Scalars['Float'];
  totalBids: Scalars['Float'];
};

export type LiveFeedPayload = {
  __typename?: 'LiveFeedPayload';
  bid?: Maybe<Bid>;
  lot?: Maybe<Lot>;
  type: LiveFeedType;
};

/** The type of live feed event. */
export enum LiveFeedType {
  BidOnLot = 'BidOnLot',
  BidRemoved = 'BidRemoved',
  ClosedLot = 'ClosedLot',
  OpenedLot = 'OpenedLot'
}

export type Lot = {
  __typename?: 'Lot';
  adjacentlotId?: Maybe<Scalars['ID']>;
  auction: Auction;
  bids: Array<Bid>;
  description?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  fairMarketValue?: Maybe<Scalars['Float']>;
  highestBid?: Maybe<Bid>;
  highestBids: Array<Bid>;
  id: Scalars['ID'];
  images: Scalars['JSON'];
  incrementAmount: Scalars['Float'];
  leaderboard: Array<LeaderboardRank>;
  lotDate?: Maybe<Scalars['DateTime']>;
  lotType: LotType;
  maximumIncrement: Scalars['Float'];
  minimumBidAmount: Scalars['Float'];
  minimumIncrement: Scalars['Float'];
  number: Scalars['Float'];
  region?: Maybe<Scalars['String']>;
  saleContents?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  totalBids: Scalars['Float'];
  variety?: Maybe<Scalars['String']>;
  vintage: Scalars['Float'];
  vintner?: Maybe<Scalars['String']>;
  yourBid?: Maybe<Bid>;
  yourBids: Array<Bid>;
};


export type LotAdjacentlotIdArgs = {
  by: Scalars['Float'];
};

export type LotConnection = {
  __typename?: 'LotConnection';
  edges: Array<LotEdge>;
  pageInfo: PageInfo;
};

export type LotEdge = {
  __typename?: 'LotEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: Lot;
};

export type LotFilterInput = {
  lotNumbers?: InputMaybe<Array<Scalars['Int']>>;
  paddleId?: InputMaybe<Scalars['String']>;
  priceFrom?: InputMaybe<Scalars['Float']>;
  priceTo?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<LotType>>;
  variety?: InputMaybe<Array<Scalars['String']>>;
  vintageFrom?: InputMaybe<Scalars['Float']>;
  vintageTo?: InputMaybe<Scalars['Float']>;
  year?: InputMaybe<Scalars['String']>;
};

/** Sort lots by these fields */
export enum LotSortBy {
  LotnumberAsc = 'LOTNUMBER_ASC',
  LotnumberDesc = 'LOTNUMBER_DESC'
}

/** The type of wine in the lot */
export enum LotType {
  Red = 'RED',
  Sparkling = 'SPARKLING',
  White = 'WHITE'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptLicenseAgreement: User;
  blockUser: Scalars['Boolean'];
  callOutBid: Bid;
  create2022AuctionAndLots: Scalars['Boolean'];
  create2023AuctionAndLots: Scalars['Boolean'];
  createBid: Bid;
  createOrUpdateAuction: Auction;
  createPaddle?: Maybe<Paddle>;
  exportAuction: Scalars['String'];
  exportAuctionsAndLots: Scalars['String'];
  importLotImages: Scalars['Boolean'];
  importLots: Scalars['Boolean'];
  removeBid: Scalars['Boolean'];
  removeLot: Scalars['Boolean'];
  removePaddle: Scalars['Boolean'];
  shareDataConsent: User;
  staggerLotEndings: Scalars['Boolean'];
  unblockUser: Scalars['Boolean'];
  update2023AuctionAndLots: Scalars['Boolean'];
  updateAuctionDetails: Auction;
  updateImagePaths: Scalars['Boolean'];
  updateMinimumBidAndIncrement: Scalars['Boolean'];
};


export type MutationAcceptLicenseAgreementArgs = {
  acceptedTerms?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBlockUserArgs = {
  id: Scalars['ID'];
};


export type MutationCallOutBidArgs = {
  amount: Scalars['Float'];
  lotId: Scalars['ID'];
  nvvip?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateBidArgs = {
  amount: Scalars['Int'];
  lotNumber: Scalars['Int'];
  paddleNumber: Scalars['Int'];
};


export type MutationCreateOrUpdateAuctionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  auctionId?: InputMaybe<Scalars['String']>;
  buyersPremiumPercentage?: InputMaybe<Scalars['Int']>;
  endsAt?: InputMaybe<Scalars['String']>;
  overheadPremiumPercentage?: InputMaybe<Scalars['Int']>;
  startsAt?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationCreatePaddleArgs = {
  accountId: Scalars['ID'];
};


export type MutationImportLotImagesArgs = {
  images: Array<Scalars['Upload']>;
};


export type MutationImportLotsArgs = {
  base64csv: Scalars['String'];
};


export type MutationRemoveBidArgs = {
  amount: Scalars['Int'];
  lotNumber: Scalars['Int'];
  paddleNumber: Scalars['Int'];
};


export type MutationRemoveLotArgs = {
  id: Scalars['ID'];
};


export type MutationRemovePaddleArgs = {
  id: Scalars['ID'];
};


export type MutationShareDataConsentArgs = {
  nvv?: InputMaybe<Scalars['Boolean']>;
  vintner?: InputMaybe<Scalars['Boolean']>;
  wineOpportunities?: InputMaybe<Scalars['Boolean']>;
};


export type MutationStaggerLotEndingsArgs = {
  auctionId: Scalars['ID'];
  intervalCount?: Scalars['Int'];
  intervalSeconds?: Scalars['Int'];
};


export type MutationUnblockUserArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateAuctionDetailsArgs = {
  auctionId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  faqLink?: InputMaybe<Scalars['String']>;
  heroImage?: InputMaybe<Scalars['Upload']>;
  heroImageMobile?: InputMaybe<Scalars['Upload']>;
  heroImageMobile2x?: InputMaybe<Scalars['Upload']>;
  youtubeId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateMinimumBidAndIncrementArgs = {
  auctionId: Scalars['ID'];
  incrementAmount: Scalars['Int'];
  maximumIncrement: Scalars['Int'];
  minimumBidAmount: Scalars['Int'];
  minimumIncrement: Scalars['Int'];
};

export type Paddle = {
  __typename?: 'Paddle';
  auction: Auction;
  bids: Array<Bid>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  number: Scalars['Float'];
  user: User;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  Auction: Auction;
  Lot: Lot;
  activeAuction?: Maybe<Auction>;
  allAuctions: AuctionConnection;
  allLots: LotConnection;
  allUsers: Array<User>;
  getAllTheAuctionTitles: Array<Scalars['String']>;
  me?: Maybe<User>;
  stats: AuctionStats;
};


export type QueryAuctionArgs = {
  id: Scalars['String'];
};


export type QueryLotArgs = {
  id: Scalars['ID'];
};


export type QueryAllAuctionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllLotsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<LotFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<LotSortBy>;
};

export type Subscription = {
  __typename?: 'Subscription';
  liveAuctionFeed: LiveFeedPayload;
  liveLotFeed: LiveFeedPayload;
  lotUpdates: LiveFeedPayload;
};


export type SubscriptionLiveAuctionFeedArgs = {
  auctionId: Scalars['ID'];
};


export type SubscriptionLiveLotFeedArgs = {
  lotIds: Array<Scalars['ID']>;
};


export type SubscriptionLotUpdatesArgs = {
  lotIds: Array<Scalars['ID']>;
};

export type User = {
  __typename?: 'User';
  auction?: Maybe<Auction>;
  blockedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  emailAddress?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  externalAccountId?: Maybe<Scalars['String']>;
  externalUserId: Scalars['String'];
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  licenseAgreedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  paddle?: Maybe<Paddle>;
  paddles: Array<Paddle>;
  pictureUrl?: Maybe<Scalars['String']>;
  shareDataNVV?: Maybe<Scalars['Boolean']>;
  shareDataVintner?: Maybe<Scalars['Boolean']>;
  shareWineOpportunities?: Maybe<Scalars['Boolean']>;
};

export type AuctionFragmentFragment = { __typename?: 'Auction', id: string, active: boolean, title: string, startsAt: any, endsAt: any, createdAt: any, buyersPremiumPercentage: number, overheadPremiumPercentage: number, faqLink: string, description: string, youtubeId: string, heroImage: string, heroImageMobile: string, heroImageMobile2x: string };

export type BidFragmentFragment = { __typename?: 'Bid', id: string, amount: number, paddleId: string, createdAt: any };

export type LeaderboardRankFragmentFragment = { __typename?: 'LeaderboardRank', id: string, paddleId: string, paddleNumber: number, totalBids: number, amount: number, createdAt: any, rank: number };

export type LotFragmentFragment = { __typename?: 'Lot', id: string, number: number, lotType: LotType, lotDate?: any | null | undefined, region?: string | null | undefined, vintner?: string | null | undefined, images: any, title: string, summary?: string | null | undefined, vintage: number, variety?: string | null | undefined, description?: string | null | undefined, saleContents?: string | null | undefined, minimumBidAmount: number, incrementAmount: number, minimumIncrement: number, maximumIncrement: number, startsAt?: any | null | undefined, endsAt?: any | null | undefined };

export type PaddleFragmentFragment = { __typename?: 'Paddle', id: string, number: number, createdAt: any };

export type AcceptLicenseAgreementMutationVariables = Exact<{
  licenseAgreement: Scalars['Boolean'];
}>;


export type AcceptLicenseAgreementMutation = { __typename?: 'Mutation', acceptLicenseAgreement: { __typename?: 'User', id: string, licenseAgreedAt?: any | null | undefined } };

export type CallOutBidMutationVariables = Exact<{
  lotId: Scalars['ID'];
  amount: Scalars['Float'];
  nvvip?: InputMaybe<Scalars['Boolean']>;
}>;


export type CallOutBidMutation = { __typename?: 'Mutation', callOutBid: { __typename?: 'Bid', id: string, amount: number, paddleId: string, createdAt: any } };

export type CreateOrUpdateAuctionMutationVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  buyersPremiumPercentage?: InputMaybe<Scalars['Int']>;
  overheadPremiumPercentage?: InputMaybe<Scalars['Int']>;
}>;


export type CreateOrUpdateAuctionMutation = { __typename?: 'Mutation', createOrUpdateAuction: { __typename?: 'Auction', id: string, active: boolean, title: string, startsAt: any, endsAt: any, createdAt: any, buyersPremiumPercentage: number, overheadPremiumPercentage: number, faqLink: string, description: string, youtubeId: string, heroImage: string, heroImageMobile: string, heroImageMobile2x: string } };

export type CreatePaddleMutationVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type CreatePaddleMutation = { __typename?: 'Mutation', createPaddle?: { __typename?: 'Paddle', id: string, number: number, createdAt: any } | null | undefined };

export type ImportLotImagesMutationVariables = Exact<{
  images: Array<Scalars['Upload']> | Scalars['Upload'];
}>;


export type ImportLotImagesMutation = { __typename?: 'Mutation', importLotImages: boolean };

export type ImportLotsMutationVariables = Exact<{
  base64csv: Scalars['String'];
}>;


export type ImportLotsMutation = { __typename?: 'Mutation', importLots: boolean };

export type ShareDataConsentMutationVariables = Exact<{
  nvv?: InputMaybe<Scalars['Boolean']>;
  vintner?: InputMaybe<Scalars['Boolean']>;
}>;


export type ShareDataConsentMutation = { __typename?: 'Mutation', shareDataConsent: { __typename?: 'User', id: string, shareDataVintner?: boolean | null | undefined, shareDataNVV?: boolean | null | undefined } };

export type StaggerLotEndingsMutationVariables = Exact<{
  auctionId: Scalars['ID'];
  intervalCount: Scalars['Int'];
  intervalSeconds: Scalars['Int'];
}>;


export type StaggerLotEndingsMutation = { __typename?: 'Mutation', staggerLotEndings: boolean };

export type UpdateAuctionDetailsMutationVariables = Exact<{
  auctionId: Scalars['ID'];
  faqLink?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  youtubeId?: InputMaybe<Scalars['String']>;
  heroImage?: InputMaybe<Scalars['Upload']>;
  heroImageMobile?: InputMaybe<Scalars['Upload']>;
  heroImageMobile2x?: InputMaybe<Scalars['Upload']>;
}>;


export type UpdateAuctionDetailsMutation = { __typename?: 'Mutation', updateAuctionDetails: { __typename?: 'Auction', id: string, active: boolean, title: string, startsAt: any, endsAt: any, createdAt: any, buyersPremiumPercentage: number, overheadPremiumPercentage: number, faqLink: string, description: string, youtubeId: string, heroImage: string, heroImageMobile: string, heroImageMobile2x: string } };

export type UpdateMinimumBidAndIncrementMutationVariables = Exact<{
  minimumBidAmount: Scalars['Int'];
  incrementAmount: Scalars['Int'];
  minimumIncrement: Scalars['Int'];
  maximumIncrement: Scalars['Int'];
  auctionId: Scalars['ID'];
}>;


export type UpdateMinimumBidAndIncrementMutation = { __typename?: 'Mutation', updateMinimumBidAndIncrement: boolean };

export type ActiveAuctionQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveAuctionQuery = { __typename?: 'Query', activeAuction?: { __typename?: 'Auction', id: string, active: boolean, title: string, startsAt: any, endsAt: any, createdAt: any, buyersPremiumPercentage: number, overheadPremiumPercentage: number, faqLink: string, description: string, youtubeId: string, heroImage: string, heroImageMobile: string, heroImageMobile2x: string } | null | undefined };

export type AllAuctionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAuctionsQuery = { __typename?: 'Query', allAuctions: { __typename?: 'AuctionConnection', edges: Array<{ __typename?: 'AuctionEdge', node: { __typename?: 'Auction', id: string, active: boolean, title: string, startsAt: any, endsAt: any, createdAt: any, buyersPremiumPercentage: number, overheadPremiumPercentage: number, faqLink: string, description: string, youtubeId: string, heroImage: string, heroImageMobile: string, heroImageMobile2x: string, lots: Array<{ __typename?: 'Lot', minimumBidAmount: number, incrementAmount: number, minimumIncrement: number, maximumIncrement: number }> } }> } };

export type AllLotsQueryVariables = Exact<{
  filter?: InputMaybe<LotFilterInput>;
  sort?: InputMaybe<LotSortBy>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type AllLotsQuery = { __typename?: 'Query', allLots: { __typename?: 'LotConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined, endCursor?: string | null | undefined }, edges: Array<{ __typename?: 'LotEdge', cursor: string, node: { __typename?: 'Lot', id: string, number: number, lotType: LotType, lotDate?: any | null | undefined, region?: string | null | undefined, vintner?: string | null | undefined, images: any, title: string, summary?: string | null | undefined, vintage: number, variety?: string | null | undefined, description?: string | null | undefined, saleContents?: string | null | undefined, minimumBidAmount: number, incrementAmount: number, minimumIncrement: number, maximumIncrement: number, startsAt?: any | null | undefined, endsAt?: any | null | undefined, yourBid?: { __typename?: 'Bid', id: string, amount: number, paddleId: string, createdAt: any } | null | undefined, highestBids: Array<{ __typename?: 'Bid', id: string, amount: number, paddleId: string, createdAt: any }> } }> } };

export type AllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUsersQuery = { __typename?: 'Query', allUsers: Array<{ __typename?: 'User', id: string, name?: string | null | undefined, externalUserId: string, externalAccountId?: string | null | undefined, emailAddress?: string | null | undefined, emailVerified?: boolean | null | undefined, pictureUrl?: string | null | undefined, shareDataNVV?: boolean | null | undefined, shareDataVintner?: boolean | null | undefined, shareWineOpportunities?: boolean | null | undefined, createdAt: any, licenseAgreedAt?: any | null | undefined, paddles: Array<{ __typename?: 'Paddle', id: string, number: number, createdAt: any }> }> };

export type LeaderboardsQueryVariables = Exact<{
  filter?: InputMaybe<LotFilterInput>;
}>;


export type LeaderboardsQuery = { __typename?: 'Query', allLots: { __typename?: 'LotConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined, endCursor?: string | null | undefined }, edges: Array<{ __typename?: 'LotEdge', cursor: string, node: { __typename?: 'Lot', id: string, number: number, lotType: LotType, lotDate?: any | null | undefined, region?: string | null | undefined, vintner?: string | null | undefined, images: any, title: string, summary?: string | null | undefined, vintage: number, variety?: string | null | undefined, description?: string | null | undefined, saleContents?: string | null | undefined, minimumBidAmount: number, incrementAmount: number, minimumIncrement: number, maximumIncrement: number, startsAt?: any | null | undefined, endsAt?: any | null | undefined, leaderboard: Array<{ __typename?: 'LeaderboardRank', id: string, paddleId: string, paddleNumber: number, totalBids: number, amount: number, createdAt: any, rank: number }> } }> } };

export type LotQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LotQuery = { __typename?: 'Query', Lot: { __typename?: 'Lot', id: string, number: number, lotType: LotType, lotDate?: any | null | undefined, region?: string | null | undefined, vintner?: string | null | undefined, images: any, title: string, summary?: string | null | undefined, vintage: number, variety?: string | null | undefined, description?: string | null | undefined, saleContents?: string | null | undefined, minimumBidAmount: number, incrementAmount: number, minimumIncrement: number, maximumIncrement: number, startsAt?: any | null | undefined, endsAt?: any | null | undefined, previousLotId?: string | null | undefined, nextLotId?: string | null | undefined, yourBid?: { __typename?: 'Bid', id: string, amount: number, paddleId: string, createdAt: any } | null | undefined, highestBids: Array<{ __typename?: 'Bid', id: string, amount: number, paddleId: string, createdAt: any }>, leaderboard: Array<{ __typename?: 'LeaderboardRank', id: string, paddleId: string, paddleNumber: number, totalBids: number, amount: number, createdAt: any, rank: number }> } };

export type MeQueryVariables = Exact<{
  year?: InputMaybe<Scalars['Float']>;
}>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, name?: string | null | undefined, emailAddress?: string | null | undefined, nickname?: string | null | undefined, isAdmin: boolean, licenseAgreedAt?: any | null | undefined, paddle?: { __typename?: 'Paddle', id: string, number: number, createdAt: any } | null | undefined } | null | undefined, activeAuction?: { __typename?: 'Auction', maxFairMarketValue: number, varieties: Array<string>, id: string, active: boolean, title: string, startsAt: any, endsAt: any, createdAt: any, buyersPremiumPercentage: number, overheadPremiumPercentage: number, faqLink: string, description: string, youtubeId: string, heroImage: string, heroImageMobile: string, heroImageMobile2x: string } | null | undefined };

export type MyLotsQueryVariables = Exact<{
  filter?: InputMaybe<LotFilterInput>;
  sort?: InputMaybe<LotSortBy>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type MyLotsQuery = { __typename?: 'Query', allLots: { __typename?: 'LotConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined, endCursor?: string | null | undefined }, edges: Array<{ __typename?: 'LotEdge', cursor: string, node: { __typename?: 'Lot', id: string, number: number, lotType: LotType, lotDate?: any | null | undefined, region?: string | null | undefined, vintner?: string | null | undefined, images: any, title: string, summary?: string | null | undefined, vintage: number, variety?: string | null | undefined, description?: string | null | undefined, saleContents?: string | null | undefined, minimumBidAmount: number, incrementAmount: number, minimumIncrement: number, maximumIncrement: number, startsAt?: any | null | undefined, endsAt?: any | null | undefined, yourBids: Array<{ __typename?: 'Bid', id: string, amount: number, paddleId: string, createdAt: any }>, highestBids: Array<{ __typename?: 'Bid', id: string, amount: number, paddleId: string, createdAt: any }> } }> } };

export type LiveAuctionFeedSubscriptionVariables = Exact<{
  auctionId: Scalars['ID'];
}>;


export type LiveAuctionFeedSubscription = { __typename?: 'Subscription', liveAuctionFeed: { __typename?: 'LiveFeedPayload', type: LiveFeedType, bid?: { __typename?: 'Bid', id: string, amount: number, paddleId: string, createdAt: any, paddle: { __typename?: 'Paddle', id: string, number: number, createdAt: any } } | null | undefined, lot?: { __typename?: 'Lot', id: string, number: number, lotType: LotType, lotDate?: any | null | undefined, region?: string | null | undefined, vintner?: string | null | undefined, images: any, title: string, summary?: string | null | undefined, vintage: number, variety?: string | null | undefined, description?: string | null | undefined, saleContents?: string | null | undefined, minimumBidAmount: number, incrementAmount: number, minimumIncrement: number, maximumIncrement: number, startsAt?: any | null | undefined, endsAt?: any | null | undefined } | null | undefined } };

export type LiveLotFeedSubscriptionVariables = Exact<{
  lotIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveLotFeedSubscription = { __typename?: 'Subscription', liveLotFeed: { __typename?: 'LiveFeedPayload', type: LiveFeedType, bid?: { __typename?: 'Bid', id: string, amount: number, paddleId: string, createdAt: any, paddle: { __typename?: 'Paddle', id: string, number: number, createdAt: any } } | null | undefined, lot?: { __typename?: 'Lot', id: string, number: number, lotType: LotType, lotDate?: any | null | undefined, region?: string | null | undefined, vintner?: string | null | undefined, images: any, title: string, summary?: string | null | undefined, vintage: number, variety?: string | null | undefined, description?: string | null | undefined, saleContents?: string | null | undefined, minimumBidAmount: number, incrementAmount: number, minimumIncrement: number, maximumIncrement: number, startsAt?: any | null | undefined, endsAt?: any | null | undefined } | null | undefined } };

export const AuctionFragmentFragmentDoc = gql`
    fragment AuctionFragment on Auction {
  id
  active
  title
  startsAt
  endsAt
  createdAt
  buyersPremiumPercentage
  overheadPremiumPercentage
  faqLink
  description
  youtubeId
  heroImage
  heroImageMobile
  heroImageMobile2x
}
    `;
export const BidFragmentFragmentDoc = gql`
    fragment BidFragment on Bid {
  id
  amount
  paddleId
  createdAt
}
    `;
export const LeaderboardRankFragmentFragmentDoc = gql`
    fragment LeaderboardRankFragment on LeaderboardRank {
  id
  paddleId
  paddleNumber
  totalBids
  amount
  createdAt
  rank
}
    `;
export const LotFragmentFragmentDoc = gql`
    fragment LotFragment on Lot {
  id
  number
  lotType
  lotDate
  region
  vintner
  images
  title
  summary
  vintage
  variety
  description
  saleContents
  minimumBidAmount
  incrementAmount
  minimumIncrement
  maximumIncrement
  startsAt
  endsAt
}
    `;
export const PaddleFragmentFragmentDoc = gql`
    fragment PaddleFragment on Paddle {
  id
  number
  createdAt
}
    `;
export const AcceptLicenseAgreementDocument = gql`
    mutation acceptLicenseAgreement($licenseAgreement: Boolean!) {
  acceptLicenseAgreement(acceptedTerms: $licenseAgreement) {
    id
    licenseAgreedAt
  }
}
    `;
export type AcceptLicenseAgreementMutationFn = Apollo.MutationFunction<AcceptLicenseAgreementMutation, AcceptLicenseAgreementMutationVariables>;

/**
 * __useAcceptLicenseAgreementMutation__
 *
 * To run a mutation, you first call `useAcceptLicenseAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptLicenseAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptLicenseAgreementMutation, { data, loading, error }] = useAcceptLicenseAgreementMutation({
 *   variables: {
 *      licenseAgreement: // value for 'licenseAgreement'
 *   },
 * });
 */
export function useAcceptLicenseAgreementMutation(baseOptions?: Apollo.MutationHookOptions<AcceptLicenseAgreementMutation, AcceptLicenseAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptLicenseAgreementMutation, AcceptLicenseAgreementMutationVariables>(AcceptLicenseAgreementDocument, options);
      }
export type AcceptLicenseAgreementMutationHookResult = ReturnType<typeof useAcceptLicenseAgreementMutation>;
export type AcceptLicenseAgreementMutationResult = Apollo.MutationResult<AcceptLicenseAgreementMutation>;
export type AcceptLicenseAgreementMutationOptions = Apollo.BaseMutationOptions<AcceptLicenseAgreementMutation, AcceptLicenseAgreementMutationVariables>;
export const CallOutBidDocument = gql`
    mutation callOutBid($lotId: ID!, $amount: Float!, $nvvip: Boolean) {
  callOutBid(lotId: $lotId, amount: $amount, nvvip: $nvvip) {
    ...BidFragment
  }
}
    ${BidFragmentFragmentDoc}`;
export type CallOutBidMutationFn = Apollo.MutationFunction<CallOutBidMutation, CallOutBidMutationVariables>;

/**
 * __useCallOutBidMutation__
 *
 * To run a mutation, you first call `useCallOutBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallOutBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callOutBidMutation, { data, loading, error }] = useCallOutBidMutation({
 *   variables: {
 *      lotId: // value for 'lotId'
 *      amount: // value for 'amount'
 *      nvvip: // value for 'nvvip'
 *   },
 * });
 */
export function useCallOutBidMutation(baseOptions?: Apollo.MutationHookOptions<CallOutBidMutation, CallOutBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CallOutBidMutation, CallOutBidMutationVariables>(CallOutBidDocument, options);
      }
export type CallOutBidMutationHookResult = ReturnType<typeof useCallOutBidMutation>;
export type CallOutBidMutationResult = Apollo.MutationResult<CallOutBidMutation>;
export type CallOutBidMutationOptions = Apollo.BaseMutationOptions<CallOutBidMutation, CallOutBidMutationVariables>;
export const CreateOrUpdateAuctionDocument = gql`
    mutation createOrUpdateAuction($auctionId: String, $title: String, $startsAt: String, $endsAt: String, $active: Boolean, $buyersPremiumPercentage: Int, $overheadPremiumPercentage: Int) {
  createOrUpdateAuction(
    auctionId: $auctionId
    title: $title
    active: $active
    startsAt: $startsAt
    endsAt: $endsAt
    buyersPremiumPercentage: $buyersPremiumPercentage
    overheadPremiumPercentage: $overheadPremiumPercentage
  ) {
    ...AuctionFragment
  }
}
    ${AuctionFragmentFragmentDoc}`;
export type CreateOrUpdateAuctionMutationFn = Apollo.MutationFunction<CreateOrUpdateAuctionMutation, CreateOrUpdateAuctionMutationVariables>;

/**
 * __useCreateOrUpdateAuctionMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateAuctionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateAuctionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateAuctionMutation, { data, loading, error }] = useCreateOrUpdateAuctionMutation({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      title: // value for 'title'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      active: // value for 'active'
 *      buyersPremiumPercentage: // value for 'buyersPremiumPercentage'
 *      overheadPremiumPercentage: // value for 'overheadPremiumPercentage'
 *   },
 * });
 */
export function useCreateOrUpdateAuctionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateAuctionMutation, CreateOrUpdateAuctionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateAuctionMutation, CreateOrUpdateAuctionMutationVariables>(CreateOrUpdateAuctionDocument, options);
      }
export type CreateOrUpdateAuctionMutationHookResult = ReturnType<typeof useCreateOrUpdateAuctionMutation>;
export type CreateOrUpdateAuctionMutationResult = Apollo.MutationResult<CreateOrUpdateAuctionMutation>;
export type CreateOrUpdateAuctionMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateAuctionMutation, CreateOrUpdateAuctionMutationVariables>;
export const CreatePaddleDocument = gql`
    mutation createPaddle($accountId: ID!) {
  createPaddle(accountId: $accountId) {
    ...PaddleFragment
  }
}
    ${PaddleFragmentFragmentDoc}`;
export type CreatePaddleMutationFn = Apollo.MutationFunction<CreatePaddleMutation, CreatePaddleMutationVariables>;

/**
 * __useCreatePaddleMutation__
 *
 * To run a mutation, you first call `useCreatePaddleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaddleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaddleMutation, { data, loading, error }] = useCreatePaddleMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCreatePaddleMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaddleMutation, CreatePaddleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaddleMutation, CreatePaddleMutationVariables>(CreatePaddleDocument, options);
      }
export type CreatePaddleMutationHookResult = ReturnType<typeof useCreatePaddleMutation>;
export type CreatePaddleMutationResult = Apollo.MutationResult<CreatePaddleMutation>;
export type CreatePaddleMutationOptions = Apollo.BaseMutationOptions<CreatePaddleMutation, CreatePaddleMutationVariables>;
export const ImportLotImagesDocument = gql`
    mutation importLotImages($images: [Upload!]!) {
  importLotImages(images: $images)
}
    `;
export type ImportLotImagesMutationFn = Apollo.MutationFunction<ImportLotImagesMutation, ImportLotImagesMutationVariables>;

/**
 * __useImportLotImagesMutation__
 *
 * To run a mutation, you first call `useImportLotImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportLotImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importLotImagesMutation, { data, loading, error }] = useImportLotImagesMutation({
 *   variables: {
 *      images: // value for 'images'
 *   },
 * });
 */
export function useImportLotImagesMutation(baseOptions?: Apollo.MutationHookOptions<ImportLotImagesMutation, ImportLotImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportLotImagesMutation, ImportLotImagesMutationVariables>(ImportLotImagesDocument, options);
      }
export type ImportLotImagesMutationHookResult = ReturnType<typeof useImportLotImagesMutation>;
export type ImportLotImagesMutationResult = Apollo.MutationResult<ImportLotImagesMutation>;
export type ImportLotImagesMutationOptions = Apollo.BaseMutationOptions<ImportLotImagesMutation, ImportLotImagesMutationVariables>;
export const ImportLotsDocument = gql`
    mutation importLots($base64csv: String!) {
  importLots(base64csv: $base64csv)
}
    `;
export type ImportLotsMutationFn = Apollo.MutationFunction<ImportLotsMutation, ImportLotsMutationVariables>;

/**
 * __useImportLotsMutation__
 *
 * To run a mutation, you first call `useImportLotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportLotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importLotsMutation, { data, loading, error }] = useImportLotsMutation({
 *   variables: {
 *      base64csv: // value for 'base64csv'
 *   },
 * });
 */
export function useImportLotsMutation(baseOptions?: Apollo.MutationHookOptions<ImportLotsMutation, ImportLotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportLotsMutation, ImportLotsMutationVariables>(ImportLotsDocument, options);
      }
export type ImportLotsMutationHookResult = ReturnType<typeof useImportLotsMutation>;
export type ImportLotsMutationResult = Apollo.MutationResult<ImportLotsMutation>;
export type ImportLotsMutationOptions = Apollo.BaseMutationOptions<ImportLotsMutation, ImportLotsMutationVariables>;
export const ShareDataConsentDocument = gql`
    mutation shareDataConsent($nvv: Boolean, $vintner: Boolean) {
  shareDataConsent(nvv: $nvv, vintner: $vintner) {
    id
    shareDataVintner
    shareDataNVV
  }
}
    `;
export type ShareDataConsentMutationFn = Apollo.MutationFunction<ShareDataConsentMutation, ShareDataConsentMutationVariables>;

/**
 * __useShareDataConsentMutation__
 *
 * To run a mutation, you first call `useShareDataConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareDataConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareDataConsentMutation, { data, loading, error }] = useShareDataConsentMutation({
 *   variables: {
 *      nvv: // value for 'nvv'
 *      vintner: // value for 'vintner'
 *   },
 * });
 */
export function useShareDataConsentMutation(baseOptions?: Apollo.MutationHookOptions<ShareDataConsentMutation, ShareDataConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareDataConsentMutation, ShareDataConsentMutationVariables>(ShareDataConsentDocument, options);
      }
export type ShareDataConsentMutationHookResult = ReturnType<typeof useShareDataConsentMutation>;
export type ShareDataConsentMutationResult = Apollo.MutationResult<ShareDataConsentMutation>;
export type ShareDataConsentMutationOptions = Apollo.BaseMutationOptions<ShareDataConsentMutation, ShareDataConsentMutationVariables>;
export const StaggerLotEndingsDocument = gql`
    mutation staggerLotEndings($auctionId: ID!, $intervalCount: Int!, $intervalSeconds: Int!) {
  staggerLotEndings(
    auctionId: $auctionId
    intervalCount: $intervalCount
    intervalSeconds: $intervalSeconds
  )
}
    `;
export type StaggerLotEndingsMutationFn = Apollo.MutationFunction<StaggerLotEndingsMutation, StaggerLotEndingsMutationVariables>;

/**
 * __useStaggerLotEndingsMutation__
 *
 * To run a mutation, you first call `useStaggerLotEndingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStaggerLotEndingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [staggerLotEndingsMutation, { data, loading, error }] = useStaggerLotEndingsMutation({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      intervalCount: // value for 'intervalCount'
 *      intervalSeconds: // value for 'intervalSeconds'
 *   },
 * });
 */
export function useStaggerLotEndingsMutation(baseOptions?: Apollo.MutationHookOptions<StaggerLotEndingsMutation, StaggerLotEndingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StaggerLotEndingsMutation, StaggerLotEndingsMutationVariables>(StaggerLotEndingsDocument, options);
      }
export type StaggerLotEndingsMutationHookResult = ReturnType<typeof useStaggerLotEndingsMutation>;
export type StaggerLotEndingsMutationResult = Apollo.MutationResult<StaggerLotEndingsMutation>;
export type StaggerLotEndingsMutationOptions = Apollo.BaseMutationOptions<StaggerLotEndingsMutation, StaggerLotEndingsMutationVariables>;
export const UpdateAuctionDetailsDocument = gql`
    mutation updateAuctionDetails($auctionId: ID!, $faqLink: String, $description: String, $youtubeId: String, $heroImage: Upload, $heroImageMobile: Upload, $heroImageMobile2x: Upload) {
  updateAuctionDetails(
    auctionId: $auctionId
    faqLink: $faqLink
    description: $description
    youtubeId: $youtubeId
    heroImage: $heroImage
    heroImageMobile: $heroImageMobile
    heroImageMobile2x: $heroImageMobile2x
  ) {
    ...AuctionFragment
  }
}
    ${AuctionFragmentFragmentDoc}`;
export type UpdateAuctionDetailsMutationFn = Apollo.MutationFunction<UpdateAuctionDetailsMutation, UpdateAuctionDetailsMutationVariables>;

/**
 * __useUpdateAuctionDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateAuctionDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuctionDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuctionDetailsMutation, { data, loading, error }] = useUpdateAuctionDetailsMutation({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      faqLink: // value for 'faqLink'
 *      description: // value for 'description'
 *      youtubeId: // value for 'youtubeId'
 *      heroImage: // value for 'heroImage'
 *      heroImageMobile: // value for 'heroImageMobile'
 *      heroImageMobile2x: // value for 'heroImageMobile2x'
 *   },
 * });
 */
export function useUpdateAuctionDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAuctionDetailsMutation, UpdateAuctionDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAuctionDetailsMutation, UpdateAuctionDetailsMutationVariables>(UpdateAuctionDetailsDocument, options);
      }
export type UpdateAuctionDetailsMutationHookResult = ReturnType<typeof useUpdateAuctionDetailsMutation>;
export type UpdateAuctionDetailsMutationResult = Apollo.MutationResult<UpdateAuctionDetailsMutation>;
export type UpdateAuctionDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateAuctionDetailsMutation, UpdateAuctionDetailsMutationVariables>;
export const UpdateMinimumBidAndIncrementDocument = gql`
    mutation UpdateMinimumBidAndIncrement($minimumBidAmount: Int!, $incrementAmount: Int!, $minimumIncrement: Int!, $maximumIncrement: Int!, $auctionId: ID!) {
  updateMinimumBidAndIncrement(
    minimumBidAmount: $minimumBidAmount
    incrementAmount: $incrementAmount
    minimumIncrement: $minimumIncrement
    maximumIncrement: $maximumIncrement
    auctionId: $auctionId
  )
}
    `;
export type UpdateMinimumBidAndIncrementMutationFn = Apollo.MutationFunction<UpdateMinimumBidAndIncrementMutation, UpdateMinimumBidAndIncrementMutationVariables>;

/**
 * __useUpdateMinimumBidAndIncrementMutation__
 *
 * To run a mutation, you first call `useUpdateMinimumBidAndIncrementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMinimumBidAndIncrementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMinimumBidAndIncrementMutation, { data, loading, error }] = useUpdateMinimumBidAndIncrementMutation({
 *   variables: {
 *      minimumBidAmount: // value for 'minimumBidAmount'
 *      incrementAmount: // value for 'incrementAmount'
 *      minimumIncrement: // value for 'minimumIncrement'
 *      maximumIncrement: // value for 'maximumIncrement'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useUpdateMinimumBidAndIncrementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMinimumBidAndIncrementMutation, UpdateMinimumBidAndIncrementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMinimumBidAndIncrementMutation, UpdateMinimumBidAndIncrementMutationVariables>(UpdateMinimumBidAndIncrementDocument, options);
      }
export type UpdateMinimumBidAndIncrementMutationHookResult = ReturnType<typeof useUpdateMinimumBidAndIncrementMutation>;
export type UpdateMinimumBidAndIncrementMutationResult = Apollo.MutationResult<UpdateMinimumBidAndIncrementMutation>;
export type UpdateMinimumBidAndIncrementMutationOptions = Apollo.BaseMutationOptions<UpdateMinimumBidAndIncrementMutation, UpdateMinimumBidAndIncrementMutationVariables>;
export const ActiveAuctionDocument = gql`
    query ActiveAuction {
  activeAuction {
    ...AuctionFragment
  }
}
    ${AuctionFragmentFragmentDoc}`;

/**
 * __useActiveAuctionQuery__
 *
 * To run a query within a React component, call `useActiveAuctionQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveAuctionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveAuctionQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveAuctionQuery(baseOptions?: Apollo.QueryHookOptions<ActiveAuctionQuery, ActiveAuctionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveAuctionQuery, ActiveAuctionQueryVariables>(ActiveAuctionDocument, options);
      }
export function useActiveAuctionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveAuctionQuery, ActiveAuctionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveAuctionQuery, ActiveAuctionQueryVariables>(ActiveAuctionDocument, options);
        }
export type ActiveAuctionQueryHookResult = ReturnType<typeof useActiveAuctionQuery>;
export type ActiveAuctionLazyQueryHookResult = ReturnType<typeof useActiveAuctionLazyQuery>;
export type ActiveAuctionQueryResult = Apollo.QueryResult<ActiveAuctionQuery, ActiveAuctionQueryVariables>;
export const AllAuctionsDocument = gql`
    query AllAuctions {
  allAuctions {
    edges {
      node {
        ...AuctionFragment
        lots {
          minimumBidAmount
          incrementAmount
          minimumIncrement
          maximumIncrement
        }
      }
    }
  }
}
    ${AuctionFragmentFragmentDoc}`;

/**
 * __useAllAuctionsQuery__
 *
 * To run a query within a React component, call `useAllAuctionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAuctionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAuctionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAuctionsQuery(baseOptions?: Apollo.QueryHookOptions<AllAuctionsQuery, AllAuctionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAuctionsQuery, AllAuctionsQueryVariables>(AllAuctionsDocument, options);
      }
export function useAllAuctionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAuctionsQuery, AllAuctionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAuctionsQuery, AllAuctionsQueryVariables>(AllAuctionsDocument, options);
        }
export type AllAuctionsQueryHookResult = ReturnType<typeof useAllAuctionsQuery>;
export type AllAuctionsLazyQueryHookResult = ReturnType<typeof useAllAuctionsLazyQuery>;
export type AllAuctionsQueryResult = Apollo.QueryResult<AllAuctionsQuery, AllAuctionsQueryVariables>;
export const AllLotsDocument = gql`
    query allLots($filter: LotFilterInput, $sort: LotSortBy, $after: String, $first: Int) {
  allLots(filter: $filter, sort: $sort, after: $after, first: $first) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...LotFragment
        yourBid {
          ...BidFragment
        }
        highestBids {
          ...BidFragment
        }
      }
    }
  }
}
    ${LotFragmentFragmentDoc}
${BidFragmentFragmentDoc}`;

/**
 * __useAllLotsQuery__
 *
 * To run a query within a React component, call `useAllLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLotsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllLotsQuery(baseOptions?: Apollo.QueryHookOptions<AllLotsQuery, AllLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLotsQuery, AllLotsQueryVariables>(AllLotsDocument, options);
      }
export function useAllLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLotsQuery, AllLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLotsQuery, AllLotsQueryVariables>(AllLotsDocument, options);
        }
export type AllLotsQueryHookResult = ReturnType<typeof useAllLotsQuery>;
export type AllLotsLazyQueryHookResult = ReturnType<typeof useAllLotsLazyQuery>;
export type AllLotsQueryResult = Apollo.QueryResult<AllLotsQuery, AllLotsQueryVariables>;
export const AllUsersDocument = gql`
    query allUsers {
  allUsers {
    id
    name
    externalUserId
    externalAccountId
    emailAddress
    emailVerified
    pictureUrl
    shareDataNVV
    shareDataVintner
    shareWineOpportunities
    paddles {
      id
      number
      createdAt
    }
    createdAt
    licenseAgreedAt
  }
}
    `;

/**
 * __useAllUsersQuery__
 *
 * To run a query within a React component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
      }
export function useAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
        }
export type AllUsersQueryHookResult = ReturnType<typeof useAllUsersQuery>;
export type AllUsersLazyQueryHookResult = ReturnType<typeof useAllUsersLazyQuery>;
export type AllUsersQueryResult = Apollo.QueryResult<AllUsersQuery, AllUsersQueryVariables>;
export const LeaderboardsDocument = gql`
    query leaderboards($filter: LotFilterInput) {
  allLots(filter: $filter) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...LotFragment
        leaderboard {
          ...LeaderboardRankFragment
        }
      }
    }
  }
}
    ${LotFragmentFragmentDoc}
${LeaderboardRankFragmentFragmentDoc}`;

/**
 * __useLeaderboardsQuery__
 *
 * To run a query within a React component, call `useLeaderboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLeaderboardsQuery(baseOptions?: Apollo.QueryHookOptions<LeaderboardsQuery, LeaderboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaderboardsQuery, LeaderboardsQueryVariables>(LeaderboardsDocument, options);
      }
export function useLeaderboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaderboardsQuery, LeaderboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaderboardsQuery, LeaderboardsQueryVariables>(LeaderboardsDocument, options);
        }
export type LeaderboardsQueryHookResult = ReturnType<typeof useLeaderboardsQuery>;
export type LeaderboardsLazyQueryHookResult = ReturnType<typeof useLeaderboardsLazyQuery>;
export type LeaderboardsQueryResult = Apollo.QueryResult<LeaderboardsQuery, LeaderboardsQueryVariables>;
export const LotDocument = gql`
    query Lot($id: ID!) {
  Lot(id: $id) {
    ...LotFragment
    previousLotId: adjacentlotId(by: -1)
    nextLotId: adjacentlotId(by: 1)
    yourBid {
      ...BidFragment
    }
    highestBids {
      ...BidFragment
    }
    leaderboard {
      ...LeaderboardRankFragment
    }
  }
}
    ${LotFragmentFragmentDoc}
${BidFragmentFragmentDoc}
${LeaderboardRankFragmentFragmentDoc}`;

/**
 * __useLotQuery__
 *
 * To run a query within a React component, call `useLotQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLotQuery(baseOptions: Apollo.QueryHookOptions<LotQuery, LotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LotQuery, LotQueryVariables>(LotDocument, options);
      }
export function useLotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LotQuery, LotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LotQuery, LotQueryVariables>(LotDocument, options);
        }
export type LotQueryHookResult = ReturnType<typeof useLotQuery>;
export type LotLazyQueryHookResult = ReturnType<typeof useLotLazyQuery>;
export type LotQueryResult = Apollo.QueryResult<LotQuery, LotQueryVariables>;
export const MeDocument = gql`
    query me($year: Float) {
  me {
    paddle {
      ...PaddleFragment
    }
    id
    name
    emailAddress
    nickname
    isAdmin
    licenseAgreedAt
  }
  activeAuction {
    ...AuctionFragment
    maxFairMarketValue
    varieties(year: $year)
  }
}
    ${PaddleFragmentFragmentDoc}
${AuctionFragmentFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MyLotsDocument = gql`
    query myLots($filter: LotFilterInput, $sort: LotSortBy, $after: String, $first: Int) {
  allLots(filter: $filter, sort: $sort, after: $after, first: $first) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...LotFragment
        yourBids {
          ...BidFragment
        }
        highestBids {
          ...BidFragment
        }
      }
    }
  }
}
    ${LotFragmentFragmentDoc}
${BidFragmentFragmentDoc}`;

/**
 * __useMyLotsQuery__
 *
 * To run a query within a React component, call `useMyLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLotsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useMyLotsQuery(baseOptions?: Apollo.QueryHookOptions<MyLotsQuery, MyLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLotsQuery, MyLotsQueryVariables>(MyLotsDocument, options);
      }
export function useMyLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLotsQuery, MyLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLotsQuery, MyLotsQueryVariables>(MyLotsDocument, options);
        }
export type MyLotsQueryHookResult = ReturnType<typeof useMyLotsQuery>;
export type MyLotsLazyQueryHookResult = ReturnType<typeof useMyLotsLazyQuery>;
export type MyLotsQueryResult = Apollo.QueryResult<MyLotsQuery, MyLotsQueryVariables>;
export const LiveAuctionFeedDocument = gql`
    subscription liveAuctionFeed($auctionId: ID!) {
  liveAuctionFeed(auctionId: $auctionId) {
    type
    bid {
      ...BidFragment
      paddle {
        ...PaddleFragment
      }
    }
    lot {
      ...LotFragment
    }
  }
}
    ${BidFragmentFragmentDoc}
${PaddleFragmentFragmentDoc}
${LotFragmentFragmentDoc}`;

/**
 * __useLiveAuctionFeedSubscription__
 *
 * To run a query within a React component, call `useLiveAuctionFeedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveAuctionFeedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveAuctionFeedSubscription({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useLiveAuctionFeedSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveAuctionFeedSubscription, LiveAuctionFeedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveAuctionFeedSubscription, LiveAuctionFeedSubscriptionVariables>(LiveAuctionFeedDocument, options);
      }
export type LiveAuctionFeedSubscriptionHookResult = ReturnType<typeof useLiveAuctionFeedSubscription>;
export type LiveAuctionFeedSubscriptionResult = Apollo.SubscriptionResult<LiveAuctionFeedSubscription>;
export const LiveLotFeedDocument = gql`
    subscription liveLotFeed($lotIds: [ID!]!) {
  liveLotFeed(lotIds: $lotIds) {
    type
    bid {
      ...BidFragment
      paddle {
        ...PaddleFragment
      }
    }
    lot {
      ...LotFragment
    }
  }
}
    ${BidFragmentFragmentDoc}
${PaddleFragmentFragmentDoc}
${LotFragmentFragmentDoc}`;

/**
 * __useLiveLotFeedSubscription__
 *
 * To run a query within a React component, call `useLiveLotFeedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveLotFeedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveLotFeedSubscription({
 *   variables: {
 *      lotIds: // value for 'lotIds'
 *   },
 * });
 */
export function useLiveLotFeedSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveLotFeedSubscription, LiveLotFeedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveLotFeedSubscription, LiveLotFeedSubscriptionVariables>(LiveLotFeedDocument, options);
      }
export type LiveLotFeedSubscriptionHookResult = ReturnType<typeof useLiveLotFeedSubscription>;
export type LiveLotFeedSubscriptionResult = Apollo.SubscriptionResult<LiveLotFeedSubscription>;